<template>
  <RxkDialog
    v-model="visible"
    title="回访记录"
    width="600px"
    :isLoading="true"
    :showCancelBtn="false"
    confirmBtnText="提交"
    @sure="sendFollow"
    @close="clear"
  >
    <div class="write-follow custom-time-content">
      <el-form
        ref="ruleFormRef"
        :model="state.formData"
        status-icon
        :rules="state.rules"
        label-width="0"
        class="write-follow-form"
      >
        <div class="tw-mb-[16px]">
          <span class="tw-font-bold">回访标签：</span>
          <el-tag
            :type="state.formData.tags.includes(item.id) ? 'primary' : 'info'"
            v-for="item in tagList"
            :key="item.id"
            style="margin-right: 10px; cursor: pointer; margin-bottom: 5px"
            @click="handleChecked(item)"
          >
            {{ item.backTagName }}
          </el-tag>
        </div>
        <div class="time-wrap" :style="{ 'margin-bottom': '8px' }">
          <span class="content-title">下次回访时间</span>
          <div class="type-right">
            <div class="fastSetting-box">
              <span
                v-for="(item, index) in state.fastSetting"
                :key="index"
                @click="dealFastDate(index)"
                :class="{ active: state.active === index }"
              >
                {{ item }}
              </span>
              <span
                ref="customSelectTimeRef"
                @click="handleCustomTab"
                v-click-outside="onClickOutside"
                :class="{ active: state.active === 4 }"
              >
                自定义时间
              </span>
            </div>
          </div>
        </div>
        <div class="textarea-content">
          <el-form-item class="textarea-input-item" prop="callbackRecord">
            <el-input
              ref="writeRecordRef"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"
              maxlength="1000"
              class="textarea-input"
              placeholder="输回访记录"
              v-model="state.formData.callbackRecord"
            />
          </el-form-item>
          <div class="follow-time-value-length">
            <span class="follow-time">
              <template v-if="state.formData.nextVisitTime">
                下次回访时间：{{ state.formData.nextVisitTime }}
              </template>
            </span>
            <span class="value-length">{{ state.formData.callbackRecord.length }} / 1000</span>
          </div>
        </div>
      </el-form>
      <el-popover
        ref="customTimePopoverRef"
        :virtual-ref="customSelectTimeRef"
        trigger="click"
        virtual-triggering
        width="216"
      >
        <el-date-picker
          v-model="state.formData.nextVisitTime"
          type="datetime"
          value-format="YYYY-MM-DD HH:mm:ss"
          format="YYYY-MM-DD HH:mm:ss"
          :clearable="false"
          placeholder="下回访时间"
          style="width: 100%"
          :teleported="false"
          @change="changeNextVisitTime"
        />
      </el-popover>
    </div>
  </RxkDialog>
</template>
<script lang="ts" setup>
import { RxkDialog } from '@/components/common/RxkDialog'
import { onMounted, reactive, ref } from 'vue'
import { isNullOrUnDef } from '@/utils/is'
import { formatToDate } from '@/utils/date'
import MyGlobalEvent from '@/utils/bus/baseBus'
import { ClickOutside as vClickOutside } from 'element-plus'
import { addVisit, getVisitLabelList, changeLabel, getVisitLabelByCustomerId } from '@/apis/cps'
import { useCallCenter } from '@/stores/modules/callCenter'

const emits = defineEmits(['update:modelValue', 'success'])

const visible = computed({
  get: () => props.modelValue,
  set: val => {
    emits('update:modelValue', val)
  }
})

const props = defineProps({
  modelValue: Boolean,
  data: {
    type: Object,
    default: () => ({})
  },
  followType: {
    type: String,
    default: ''
  },
  finishClose: {
    type: Boolean,
    default: true
  }
})
const state = reactive({
  formData: {
    nextVisitTime: '',
    callbackRecord: '',
    tags: [] as number[]
  },
  rules: {},
  fastSetting: ['15分钟后', '30分钟后', '1天后', '3天后'],
  active: -1,
  fileToolBtnIcon: 'icon-qiyong',
  showViewer: false,
  showImgList: [] as string[]
})
const ruleFormRef = ref()
const writeRecordRef = ref()

const dealFastDate = (i: number) => {
  state.active = i
  let time: number | undefined = undefined
  switch (i) {
    case 0: // 15分钟后
      time = new Date().getTime() + 15 * 60 * 1000
      break
    case 1: // 30分钟后
      time = new Date().getTime() + 30 * 60 * 1000
      break
    case 2: // 1天后
      time = new Date().getTime() + 24 * 60 * 60 * 1000
      break
    case 3: // 3天后
      time = new Date().getTime() + 3 * 24 * 60 * 60 * 1000
      break
  }
  state.formData.nextVisitTime = formatToDate(time, 'YYYY-MM-DD HH:mm:ss')
}

// 发送回访记录
const sendFollow = (fn: Fn) => {
  if (state.formData.callbackRecord === '' || isNullOrUnDef(state.formData.callbackRecord.trim())) {
    ElMessage.error('请填写回访内容')
    fn?.()
    return
  }
  addVisit({
    ...state.formData,
    customerId: callCenter?.cpsShopProductId
  })
    .then(() => {
      fn?.()
      ElMessage.success('添加回访记录成功')
      MyGlobalEvent.$emit('refreshVisitRecord') // 通知列表刷新数据
      emits('success')
      clear()
      if (props.finishClose) {
        emits('update:modelValue', false)
      }
    })
    .catch(() => {
      fn?.()
    })
}
function clear() {
  ruleFormRef.value?.resetFields()
  state.active = -1
  state.formData.nextVisitTime = ''
}
const customSelectTimeRef = ref()
const customTimePopoverRef = ref()
const onClickOutside = () => {
  unref(customTimePopoverRef).popperRef?.delayHide?.()
}
const changeNextVisitTime = () => {
  unref(customTimePopoverRef)?.hide?.()
}
const handleCustomTab = () => {
  state.active = 4
}
onMounted(() => {
  setTimeout(() => {
    writeRecordRef.value?.focus?.()
  }, 1000)
})
defineExpose({
  state,
  sendFollow
})

// 标签相关
const callCenter = useCallCenter()
const tagList = ref<Recordable[]>([])
watch(visible, async val => {
  if (val) {
    getTagList()
    const data = await getVisitLabelByCustomerId(callCenter.cpsShopProductId)
    if (data) {
      state.formData.tags = data || []
    }
  }
})
function getTagList() {
  try {
    getVisitLabelList({}).then(res => {
      tagList.value = res
    })
  } catch (error) {
    console.log(error)
  }
}

async function handleChecked(tag: Recordable) {
  const res = state.formData.tags.find(item => item === tag.id)
  if (res) {
    state.formData.tags = state.formData.tags.filter(item => item !== tag.id)
  } else {
    state.formData.tags.push(tag.id)
  }
  try {
    await changeLabel({
      callbackTags: state.formData.tags,
      customerId: callCenter?.cpsShopProductId
    })
    emits('success')
  } catch (e) {
    console.log(e)
  }
}
</script>

<style lang="scss" scoped>
$bg-color: #f4f4f5;

.write-follow {
  padding: 16px 24px 0;

  .write-follow-form {
    :deep(.time-wrap) {
      @include flex-center(row, space-between, center);
      gap: 8px;
      .remind-time-item {
        flex: 1;
        margin-bottom: 0;
      }
      .remind-time {
        width: 100%;
      }
    }
  }

  .type-right {
    .fastSetting-box {
      display: flex;
      flex: 1;
      margin-bottom: 0;

      span {
        cursor: pointer;
        font-size: 12px;
        display: inline-block;
        border-radius: 2px;
        line-height: 20px;
        color: #5687ff;
        padding: 2px 8px;
        &.active {
          background-color: #eef3ff;
        }
        &.disabled {
          cursor: not-allowed;
        }
      }
    }
  }

  .textarea-content {
    background-color: $bg-color;
    position: relative;
    padding-bottom: 10px;
    :deep(.el-textarea) {
      border: none;
      .el-textarea__inner {
        background-color: $bg-color;
        border: none;
        box-shadow: none;
        resize: none;
      }
    }
  }
  .file-list {
    margin-top: 10px;
    .file-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      align-self: stretch;
      border-radius: 4px;
      background: #fff;
      height: 28px;
      line-height: 28px;
      margin-top: 6px;
      @include flex-center(row, space-between, center);
      &:hover {
        background: #f5f7fa;
      }
      .mini-img {
        width: 24px;
        height: 24px;
        border-radius: 4px;
        margin-right: 8px;
      }
      .file-icon {
        font-size: 12px;
        color: #999999;
        text-align: center;
        width: 24px;
      }
      .file-name-icon {
        @include flex-center(row, normal, center);
        width: calc(100% - 48px);
      }
      .file-name {
        color: #666;
        line-height: normal;
        max-width: calc(100% - 33px);
        font-size: 12px;
        margin-top: 1px;
      }
      .file-btn-icon {
        font-size: 13px;
        flex-shrink: 0;
        margin-top: 3px;
        cursor: pointer;
      }
      .icon-qiyong {
        color: #5dc144;
      }
      .icon-circle-close1 {
        color: #f44d4d;
      }
    }
  }
  .follow-time-value-length {
    @include flex-center(row, space-between, center);
    padding: 0 8px;

    .value-length {
      font-size: 12px;
      color: #aaa;
    }
  }
  .follow-time {
    color: #fcac33;
    font-size: 12px;
  }
  .footer-content {
    @include flex-center(row, space-between, center);
    padding: 0 8px 8px;
  }
}
</style>
